import { cn } from "@/lib/utils";

export const StatCard = ({ title, value, icon: Icon, accent = "primary", hint, testId }) => {
  const accents = {
    primary: "bg-primary/10 text-primary",
    accent: "bg-cyan-500/10 text-cyan-600 dark:text-cyan-400",
    success: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
    warning: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
    danger: "bg-red-500/10 text-red-600 dark:text-red-400",
  };
  return (
    <div
      data-testid={testId}
      className="group rounded-xl border border-border bg-card p-5 shadow-[0_2px_10px_rgba(0,0,0,0.03)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
    >
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">
            {title}
          </p>
          <p className="mt-2 truncate font-heading text-2xl font-bold tracking-tight text-foreground">
            {value}
          </p>
          {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
        </div>
        <div className={cn("flex h-11 w-11 shrink-0 items-center justify-center rounded-lg", accents[accent])}>
          {Icon && <Icon className="h-5 w-5" strokeWidth={1.8} />}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
